(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');
      this.isTransparent = document.querySelector('.header-wrapper').classList.contains('transparent-header');

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (this.isTransparent) {
        if (scrollTop > this.headerBounds.bottom) {
          this.header.classList.add('scrolled-past-header');
          this.header.classList.remove('transparent-header');
          if (scrollTop > this.currentScrollTop) {
            this.header.classList.add('shopify-section-header-hidden');
          } else {
            this.header.classList.remove('shopify-section-header-hidden');
          }
        } else {
          this.header.classList.remove('scrolled-past-header', 'shopify-section-header-hidden');
          this.header.classList.add('transparent-header');
        }
        this.currentScrollTop = scrollTop;
        return;
      }

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close()); 
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lookbook"] && !Shopify.designMode) return;
  try {
     
  class luminLookBook extends HTMLElement {
    constructor () {
      super()

      this.injectVendorScripts()
      this.querySelectorAll('.lumin-lookbook-point-list-item').forEach((elem) => {
        this.handleTooltip(elem)
      })
    } 
    
    async injectVendorScripts () {
      if (!window.FloatingUICore) {
        const script = document.createElement('script')
        script.setAttribute('src', 'https://cdn.jsdelivr.net/npm/@floating-ui/core@1.6.0')
        document.head.appendChild(script) 
      }
      if (!window.FloatingUIDOM) {
        await new Promise(r => setTimeout(r, 500))

        const script = document.createElement('script')
        script.setAttribute('src', 'https://cdn.jsdelivr.net/npm/@floating-ui/dom@1.6.1')
        document.head.appendChild(script)
      }
    }

    handleTooltip(elem) {
      const btn = elem.querySelector('button')
      const tooltip = elem.querySelector('.lumin-tooltip')

      function update() {
        window.FloatingUIDOM.computePosition(btn, tooltip, {
          middleware: [
            window.FloatingUIDOM.offset(0),
            window.FloatingUIDOM.autoPlacement()
          ],
        }).then(({x, y}) => {
          Object.assign(tooltip.style, {
            left: `${x}px`,
            top: `${y}px`,
          })
        })
      }

      function showTooltip() {
        tooltip.classList.add('show')
        update()
      }
      
      function hideTooltip() {
        setTimeout(() => {
          tooltip.classList.remove('show')
          tooltip.classList.add('hiding')
          setTimeout(() => {
            tooltip.classList.remove('hiding')
          }, 200)
        }, 100)
      }
      
      if (window.matchMedia("(pointer: coarse)").matches) {
        [
          ['mouseenter', showTooltip],
          ['mouseleave', hideTooltip],
          ['focus', showTooltip],
          ['blur', hideTooltip],
        ].forEach(([event, listener]) => {
          btn.addEventListener(event, listener)
        })
      } else {
        [
          ['focus', showTooltip],
          ['blur', hideTooltip],
        ].forEach(([event, listener]) => {
          btn.addEventListener(event, listener)
        })
      }
    }
  }
  customElements.define('lumin-lookbook', luminLookBook)

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mc-hero"] && !Shopify.designMode) return;
  try {
    
(()=>{const bind=root=>root.querySelectorAll('[data-mc-lights]').forEach(button=>{
 if(button.dataset.bound)return;button.dataset.bound='true';
 const hero=button.closest('.mc-hero'),off=hero.querySelector('.mc-hero__off');let desired=true,ready;
 const prepare=()=>ready||(ready=new Promise(resolve=>{if(!off)return resolve(false);const done=()=>{if(!off.naturalWidth)return resolve(false);if(off.decode)off.decode().then(()=>resolve(true),()=>resolve(true));else resolve(true)};if(off.complete)done();else{off.addEventListener('load',done,{once:true});off.addEventListener('error',()=>resolve(false),{once:true});}}));
 prepare();
 button.addEventListener('click',async()=>{
  desired=!desired;button.setAttribute('aria-pressed',String(desired));button.querySelector('[data-mc-light-label]').textContent=desired?button.dataset.on:button.dataset.off;
  button.setAttribute('aria-busy','true');const ok=await prepare();button.removeAttribute('aria-busy');
  if(!ok){desired=true;button.setAttribute('aria-pressed','true');button.querySelector('[data-mc-light-label]').textContent=button.dataset.on;}
  hero.dataset.lights=desired?'on':'off';
 });
 });bind(document);document.addEventListener('shopify:section:load',e=>bind(e.target));})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mc-lights-demo"] && !Shopify.designMode) return;
  try {
    
(()=>{const bind=root=>root.querySelectorAll('[data-mc-demo]').forEach(el=>{if(el.dataset.bound)return;el.dataset.bound='true';const b=el.querySelector('[data-mc-demo-toggle]');b.addEventListener('click',()=>{const on=b.getAttribute('aria-pressed')!=='true';b.setAttribute('aria-pressed',String(on));el.dataset.lights=on?'on':'off';el.querySelector('[data-mc-demo-label]').textContent=on?b.dataset.on:b.dataset.off;});const variants=JSON.parse(el.querySelector('[data-mc-demo-variants]').textContent).variants;const paint=id=>{const variant=variants.find(v=>String(v.id)===String(id));if(!variant)return;const image=el.querySelector('.mc-demo__on');image.removeAttribute('srcset');image.src=variant.image;};if(typeof subscribe==='function'&&typeof PUB_SUB_EVENTS!=='undefined'){subscribe(PUB_SUB_EVENTS.variantChange,e=>paint(e.data?.variant?.id));}});bind(document);document.addEventListener('shopify:section:load',e=>bind(e.target));})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mc-pair-selector"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mc-pair-selector')) {
    customElements.define('mc-pair-selector', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.products = JSON.parse(this.querySelector('[data-pair-products]').textContent);
        if (!this.products.length) return;
        this.strings = JSON.parse(this.querySelector('[data-pair-strings]').textContent);
        this.step = 0;
        this.choices = [null, null];
        this.busy = false;
        this.added = false;
        this.actualSubtotal = null;
        this.money = new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: this.dataset.currency, currencyDisplay: 'code' });
        this.cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
        this.addButton = this.querySelector('[data-add]');
        if (this.cart) this.addButton.setAttribute('aria-haspopup', 'dialog');
        this.addEventListener('change', event => this.onChoice(event));
        this.addEventListener('click', event => this.onClick(event));
        this.render();
      }

      format(amount) { return this.money.format(amount / 100); }

      onChoice(event) {
        if (this.busy || this.added || this.step > 1) return;
        const card = event.target.closest('[data-product-card]');
        if (!card || !event.target.matches('[data-product-choice], [data-variant-select]')) return;
        const product = this.products.find(item => String(item.id) === card.dataset.productCard);
        const variant = product.variants.find(item => String(item.id) === card.querySelector('[data-variant-select]').value);
        if (!variant || !variant.available) return;
        this.choices[this.step] = { product, variant };
        this.clearError();
        this.render();
      }

      onClick(event) {
        const button = event.target.closest('button');
        if (!button || this.busy || this.added) return;
        if (button.matches('[data-next]')) this.goTo(this.step + 1);
        if (button.matches('[data-back]')) this.goTo(this.step - 1);
        if (button.matches('[data-step]')) this.goTo(Number(button.dataset.step));
        if (button.matches('[data-edit]')) this.goTo(Number(button.dataset.edit));
        if (button.matches('[data-add]')) this.addPairs();
      }

      goTo(step) {
        if (step < 0 || step > 2 || (step > 0 && !this.choices[0]) || (step > 1 && !this.choices[1])) return;
        this.step = step;
        this.clearError();
        const update = () => {
          this.render();
          const heading = this.querySelector(step === 2 ? '[data-review] h2' : '[data-step-heading]');
          heading.focus({ preventScroll: true });
          heading.scrollIntoView({ block: 'start', behavior: 'auto' });
        };
        if (document.startViewTransition && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) document.startViewTransition(update);
        else update();
      }

      render() {
        this.querySelector('[data-chooser]').hidden = this.step === 2;
        this.querySelector('[data-review]').hidden = this.step !== 2;
        this.querySelector('[data-step-heading]').textContent = this.step === 0 ? this.strings.chooseFirst : this.strings.chooseSecond;
        this.querySelector('[data-step-description]').textContent = this.step === 0 ? this.strings.firstDescription : this.strings.secondDescription;
        this.querySelector('[data-step-count]').textContent = this.step === 0 ? this.strings.stepOne : this.strings.stepTwo;
        this.querySelectorAll('[data-step]').forEach(button => {
          const index = Number(button.dataset.step);
          button.disabled = this.added || this.busy || (index > 0 && !this.choices[0]) || (index > 1 && !this.choices[1]);
          if (index === this.step) button.setAttribute('aria-current', 'step');
          else button.removeAttribute('aria-current');
        });
        this.querySelectorAll('[data-product-card]').forEach(card => {
          const product = this.products.find(item => String(item.id) === card.dataset.productCard);
          const selected = this.choices[this.step];
          const matches = selected && selected.product.id === product.id;
          card.querySelector('[data-product-choice]').checked = Boolean(matches);
          const select = card.querySelector('[data-variant-select]');
          if (matches) select.value = String(selected.variant.id);
          const variant = product.variants.find(item => String(item.id) === select.value);
          if (variant) {
            card.querySelector('[data-card-price]').textContent = this.step === 1 ? this.strings.freeWithOffer : this.format(variant.price);
            const image = card.querySelector('.mc-pair-selector__image img');
            const source = variant.image || product.image;
            if (image && source && image.getAttribute('src') !== source) {
              image.removeAttribute('srcset');
              image.src = source;
            }
          }
        });
        this.choices.forEach((choice, index) => {
          const summary = this.querySelector(`[data-summary-item="${index}"]`);
          const image = summary.querySelector('[data-summary-image]');
          const source = choice && (choice.variant.image || choice.product.image);
          image.hidden = !source;
          if (source) image.src = source;
          summary.querySelector('[data-summary-number]').hidden = Boolean(source);
          summary.querySelector('[data-summary-title]').textContent = choice ? choice.product.title : this.strings.notChosen;
          summary.querySelector('[data-summary-variant]').textContent = choice && !choice.product.defaultOnly ? choice.variant.title : '';
          summary.querySelector('[data-edit]').hidden = !choice || this.added;
          if (choice) {
            const review = this.querySelector(`[data-review-item="${index}"]`);
            review.querySelector('[data-review-title]').textContent = choice.product.title;
            review.querySelector('[data-review-variant]').textContent = choice.product.defaultOnly ? '' : choice.variant.title;
            review.querySelector('[data-review-price]').textContent = index === 1 ? this.strings.freeWithOffer : this.format(Math.max(...this.choices.filter(Boolean).map(item => item.variant.price)));
            const reviewImage = review.querySelector('[data-review-image]');
            reviewImage.hidden = !source;
            if (source) reviewImage.src = source;
          }
        });
        const prices = this.choices.filter(Boolean).map(choice => choice.variant.price);
        this.querySelector('[data-subtotal]').textContent = this.actualSubtotal !== null ? this.format(this.actualSubtotal) : (prices.length ? this.format(Math.max(...prices)) : this.strings.chooseToTotal);
        const next = this.querySelector('[data-next]');
        next.hidden = this.step === 2 || this.added;
        next.disabled = !this.choices[this.step] || this.busy;
        next.firstChild.textContent = this.step === 0 ? this.strings.continueFree : this.strings.reviewPairing;
        this.querySelector('[data-back]').hidden = this.step === 0 || this.added;
        this.addButton.hidden = this.step !== 2 || this.added;
        this.addButton.disabled = this.busy || this.choices.some(choice => !choice);
        this.querySelectorAll('[data-edit], [data-back]').forEach(button => { button.disabled = this.busy || this.added; });
      }

      clearError() {
        const error = this.querySelector('[data-error]');
        error.hidden = true;
        error.textContent = '';
      }

      showError(message) {
        const error = this.querySelector('[data-error]');
        error.textContent = message;
        error.hidden = false;
        error.focus({ preventScroll: true });
      }

      publishCart(event, payload) {
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS[event], payload);
      }

      async getCart() {
        const response = await fetch(`${this.dataset.cartUrl}.js`, { headers: { Accept: 'application/json' }, cache: 'no-store' });
        if (!response.ok) throw new Error(this.strings.uncertainError);
        return response.json();
      }

      inspectOffer(cartState, group) {
        const lines = cartState.items.filter(item => item.properties && item.properties._mc_pair_set === group);
        const quantity = lines.reduce((total, item) => total + item.quantity, 0);
        const total = lines.reduce((sum, item) => sum + item.final_line_price, 0);
        const discount = lines.reduce((sum, item) => sum + (item.line_level_discount_allocations || []).reduce((amount, allocation) => amount + allocation.amount, 0), 0);
        const prices = this.choices.map(choice => choice.variant.price);
        return { quantity, total, verified: quantity === 2 && cartState.currency === this.dataset.currency && discount >= Math.min(...prices) && total <= Math.max(...prices) };
      }

      async renderNativeCart(response) {
        if (!this.cart) { window.location.assign(this.dataset.cartUrl); return; }
        const sections = this.cart.getSectionsToRender();
        if (!response.sections || sections.some(section => !response.sections[section.id])) {
          const url = new URL(window.location.href);
          url.searchParams.set('sections', sections.map(section => section.id).join(','));
          const sectionResponse = await fetch(url, { headers: { Accept: 'application/json' }, cache: 'no-store' });
          if (!sectionResponse.ok) throw new Error(this.strings.drawerError);
          response.sections = await sectionResponse.json();
        }
        if (sections.some(section => !response.sections[section.id])) throw new Error(this.strings.drawerError);
        const firstItem = response.items && response.items[0];
        if (firstItem) { response.id = firstItem.id; response.key = firstItem.key; }
        this.cart.classList.remove('is-empty');
        this.cart.renderContents(response);
      }

      finishAdded(cartState, group, response) {
        const offer = this.inspectOffer(cartState, group);
        if (offer.quantity !== 2) return false;
        this.added = true;
        this.actualSubtotal = offer.total;
        this.querySelector('[data-view-cart]').hidden = false;
        this.publishCart('cartUpdate', { source: 'product-form', productVariantId: this.choices[0].variant.id, cartData: response });
        if (offer.verified) {
          this.querySelector('[data-status]').textContent = this.strings.added;
          this.querySelector('[data-offer-note]').textContent = this.strings.offerVerified;
          this.renderNativeCart(response).catch(() => this.showError(this.strings.drawerError));
        } else {
          this.querySelector('[data-status]').textContent = '';
          this.querySelector('[data-offer-note]').textContent = this.strings.offerMissing;
          this.showError(this.strings.offerMissing);
        }
        this.render();
        this.querySelector('[data-subtotal]').textContent = this.format(offer.total);
        return true;
      }

      async addPairs() {
        if (this.busy || this.added) return;
        if (this.choices.some(choice => !choice)) { this.showError(this.strings.chooseBoth); return; }
        if (this.choices.some(choice => !choice.variant.available)) { this.showError(this.strings.unavailable); return; }
        this.clearError();
        this.busy = true;
        this.render();
        this.addButton.setAttribute('aria-busy', 'true');
        this.addButton.firstChild.textContent = this.strings.adding;
        this.querySelector('[data-status]').textContent = this.strings.adding;
        const group = `mc-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
        const quantities = new Map();
        this.choices.forEach(choice => quantities.set(choice.variant.id, (quantities.get(choice.variant.id) || 0) + 1));
        const formData = new FormData();
        Array.from(quantities).forEach(([id, quantity], index) => {
          formData.append(`items[${index}][id]`, id);
          formData.append(`items[${index}][quantity]`, quantity);
          formData.append(`items[${index}][properties][_mc_pair_set]`, group);
        });
        if (this.cart) {
          formData.append('sections', this.cart.getSectionsToRender().map(section => section.id));
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(this.querySelector('[data-view-cart]'));
        }
        const config = typeof fetchConfig === 'function' ? fetchConfig('javascript') : { method: 'POST', headers: { Accept: 'application/json' } };
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];
        config.body = formData;
        let responseData;
        let knownRejected = false;
        try {
          const response = await fetch(this.dataset.cartAddUrl, config);
          responseData = await response.json();
          if (!response.ok || responseData.status) {
            knownRejected = true;
            const message = typeof responseData.description === 'string' ? responseData.description : this.strings.addError;
            this.publishCart('cartError', { source: 'product-form', productVariantId: this.choices[0].variant.id, errors: responseData.errors || responseData.description, message: responseData.message });
            throw new Error(message);
          }
          const cartState = await this.getCart();
          if (!this.finishAdded(cartState, group, responseData)) throw new Error(this.strings.uncertainError);
        } catch (error) {
          try {
            const cartState = await this.getCart();
            const offer = this.inspectOffer(cartState, group);
            if (!this.finishAdded(cartState, group, responseData || { items: cartState.items.filter(item => item.properties && item.properties._mc_pair_set === group) })) {
              if (offer.quantity > 0 || !knownRejected) {
                this.added = true;
                this.actualSubtotal = offer.quantity > 0 ? offer.total : null;
                this.querySelector('[data-view-cart]').hidden = false;
                this.showError(this.strings.uncertainError);
              } else this.showError(error.message);
              this.querySelector('[data-status]').textContent = '';
            }
          } catch (_) {
            this.added = true;
            this.querySelector('[data-view-cart]').hidden = false;
            this.showError(this.strings.uncertainError);
            this.querySelector('[data-status]').textContent = '';
          }
        } finally {
          this.busy = false;
          this.addButton.removeAttribute('aria-busy');
          this.addButton.firstChild.textContent = this.strings.addBoth;
          this.render();

        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-gallery"] && !Shopify.designMode) return;
  try {
    

class VideoGallery extends HTMLElement {
  constructor() {
    super();
    this.deferredMedia = this.querySelector(".video-gallery__media");
    this.videoPlaylist = this.querySelector(".video-gallery__thumbnails");
    this.activeVideoTitle = this.querySelector(".video-gallery__active-video-title");
    this.videoPlayer = null;

    this.handleVideoClick = this.handleVideoClick.bind(this);
  }

  connectedCallback() {
    this.videoPlaylist.addEventListener("click", this.handleVideoClick);
  }

  disconnectedCallback() {
    this.videoPlaylist.removeEventListener("click", this.handleVideoClick);
  }

  getVideoEmbedRef = () => {
    return document.querySelector('.video-gallery__embed');
  }

  getVideoPlayerRef = () => {
    return document.querySelector('.video-gallery__player');
  }

  clearExistingMedia = (type) => {
    
    const existingEmbed = this.getVideoEmbedRef();
    const existingPlayer = this.getVideoPlayerRef();

    if (type === 'video' && existingEmbed) {
      existingEmbed.remove();
    }

    if (type === 'embed' && existingPlayer) {
      existingPlayer.remove();
    }
  }

  handleVideoClick = (e) => {

    const thumbnailElement = event.target.closest(".video-gallery__thumbnail");
    if (!thumbnailElement) {
      console.error('Thumbnail element not found');
      return;
    }
    
    if (this.deferredMedia) {
      this.deferredMedia.loadContent(false);
    }

    const videoURL = thumbnailElement.dataset.videoUrl;
    const embedType = thumbnailElement.dataset.embedUrlType;
    const embedID = thumbnailElement.dataset.embedUrlId;
    const videoTitle = thumbnailElement.dataset.videoTitle;
    
    if (videoURL) {
        // Load video
        this.loadVideo(videoURL, videoTitle);
    } else if (embedType && embedID) {
        // Load embed
        this.loadEmbed(embedType, embedID, videoTitle);
    } else {
        console.error('Video URL or embed URL not found');
    }

    this.scrollToVideoPlayer(); 
  }

  // Function to scroll to the video player
  scrollToVideoPlayer = () => {
    if (!this.videoPlayer) {
      console.error('Video player element not found');
      return;
    }

    const videoPlayerPosition = this.videoPlayer.getBoundingClientRect().top + window.scrollY - 150;

    window.scrollTo({
      top: videoPlayerPosition,
      behavior: 'smooth'
    });
  }

  loadVideo = (videoURL, videoTitle) => {

    this.clearExistingMedia('video');

    // Get the video player
    this.videoPlayer = this.getVideoPlayerRef();

    if (!this.videoPlayer) {
      console.log('Video player element not found, creating it');
      this.videoPlayer = document.createElement('video');
      this.videoPlayer.classList.add('video-gallery__player');
      this.videoPlayer.setAttribute('playsinline', '');
      this.videoPlayer.setAttribute('autoplay', '');
      this.videoPlayer.setAttribute('controls', '');

      this.deferredMedia.appendChild(this.videoPlayer);
    }
    
    // Set video source and title
    this.videoPlayer.src = videoURL;
    this.videoPlayer.load();

    // Play the video
    this.videoPlayer.addEventListener('loadedmetadata', function loadedMetadataHandler() {
      this.videoPlayer.play()
        .then(() => {
          console.log('Video started playing');
          // Remove the event listener after playback starts
          this.videoPlayer.removeEventListener('loadedmetadata', loadedMetadataHandler);
        })
        .catch((error) => {
          console.error('Error playing video:', error);
        });
    }.bind(this));

    // Update the active video title
    this.activeVideoTitle.innerText = videoTitle;
  }

  loadEmbed = (embedType, embedID, videoTitle) => {

    if (embedType !== 'youtube' && embedType !== 'vimeo') {
      console.error('Invalid embed type');
      return;
    }

    this.clearExistingMedia('embed');

    const embedURL = (embedType == 'youtube') ? `https://www.youtube.com/embed/${embedID}?autoplay=1`: `https://player.vimeo.com/video/${videoId}?autoplay=1`;

    let embedElement = this.getVideoEmbedRef();

    if (!embedElement) {
      embedElement = document.createElement('iframe');
      embedElement.classList.add('video-gallery__embed');
      embedElement.setAttribute('allow', 'autoplay; encrypted-media');
      embedElement.setAttribute('allowfullscreen', '');
      this.deferredMedia.appendChild(embedElement);
    }
    
    embedElement.src = embedURL;
    embedElement.setAttribute('title', videoTitle);

    this.videoPlayer = embedElement;

    this.activeVideoTitle.innerText = videoTitle;
  }

}

customElements.define('video-gallery', VideoGallery);


  } catch(e) { console.error(e); }
})();
})();
